"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var liCountry = exports.liCountry = function liCountry(t) {
  return {
    id: 'LI',
    name: t('Liechtenstein'),
    flag: '🇱🇮',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 9490 or 9497',
    phonePrefix: '423',
    phoneLength: 7,
    pricingVersion: 14,
    timezone: 'Europe/Vaduz',
    currency: 'EUR'
  };
};